import { type CodigoDePapel, PAPEIS, type StatusDoUsuario } from '@locaveri/shared'
import { CircleCheck, CircleSlash, Clock, ShieldCheck } from 'lucide-react'
import type { ReactElement } from 'react'

import { Badge } from '@/components/ui/badge'

/**
 * Selos de usuário.
 *
 * Regra do CLAUDE.md: status nunca depende só de cor — cada selo tem ÍCONE e
 * RÓTULO. Em uma tabela de operação isso não é preferência estética: é o que
 * permite ler a coluna em tela ruim, em daltonismo e em impressão preto e
 * branco.
 */

const STATUS = {
  ATIVO: { rotulo: 'Ativo', variante: 'success', icone: CircleCheck },
  PENDENTE: { rotulo: 'Pendente', variante: 'warning', icone: Clock },
  BLOQUEADO: { rotulo: 'Bloqueado', variante: 'danger', icone: CircleSlash },
} as const

export function BadgeDeStatusDoUsuario({
  status,
}: {
  readonly status: StatusDoUsuario
}): ReactElement {
  const { rotulo, variante, icone: Icone } = STATUS[status]

  return (
    <Badge variant={variante}>
      <Icone aria-hidden="true" />
      {rotulo}
    </Badge>
  )
}

/** Selo do segundo fator. Só aparece quando ATIVO — ausência não é alarme. */
export function BadgeDe2fa({ ativo }: { readonly ativo: boolean }): ReactElement | null {
  if (!ativo) {
    return null
  }

  return (
    <Badge variant="neutral" title="Verificação em duas etapas ativa">
      <ShieldCheck aria-hidden="true" />
      2FA
    </Badge>
  )
}

export function ListaDePapeis({
  papeis,
}: {
  readonly papeis: readonly CodigoDePapel[]
}): ReactElement {
  if (papeis.length === 0) {
    return <span className="text-sm text-fg-muted">sem papel</span>
  }

  return (
    <span className="flex flex-wrap gap-1">
      {papeis.map((papel) => (
        <Badge key={papel} variant="outline">
          {PAPEIS[papel].nome}
        </Badge>
      ))}
    </span>
  )
}
